<template>
  <div>
    <div class="nav-bar-container">
      <div class="nav-bar">
        <span class="summary-hello">{{ $t("hello") }}</span>
        <span class="summary-name">{{ (currentUserContact || {}).name || currentUser.name }},</span>
        <span class="summary-hello">{{ $t("welcome") }}</span>
        <br>
        <label class="summary-hello emphasis">{{ $t("settings.title") }}</label>
      </div>
    </div>

    <div class="vendor-detail-container">
      <vendor-detail :contactId="deep(currentUserContact, 'id')" />
    </div>
  </div>
</template>

<script>
import VendorDetail from '@/modules/settings/vendors/VendorDetail'
import { mapGetters } from 'vuex'

export default {
  name: 'ContractorSettings',
  components: {
    VendorDetail,
  },
  computed: {
    ...mapGetters('user', ['currentUser', 'currentUserContact']),
    deep () {
      return deep
    },
  },
}
</script>

<style scoped lang="scss">
@import "~styles/dashboard/style.scss";
@import "~styles/settings/style.scss";

.vendor-detail-container {
  max-width: 1440px;
  margin: 0 auto;
}

.tab-container {
  padding: 10px 30px;
}
.tab-content {
  width: 100%;
}

</style>
